import { render, staticRenderFns } from "./parkpassrule.vue?vue&type=template&id=28f34fa6&"
import script from "./parkpassrule.vue?vue&type=script&lang=js&"
export * from "./parkpassrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports